import { ReactNode } from 'react';
import { ErrorBoundary as ReactErrorBoundary, FallbackProps } from 'react-error-boundary';

import { useAnalytics } from 'hooks/useAnalytics';
import { DataDogLogger } from 'utils/dataDog';
import { ANALYTICS } from 'analytics/constants';
import { AnalyticErrorShownDetailsType } from 'analytics/types';

import DefaultFallback from './Fallback';

const ErrorBoundary = (
  props: PropsWithChildren<{ fallbackRender?: (props: FallbackProps) => ReactNode }> | any,
) => {
  const { fallbackRender } = props;
  const { trackEvent } = useAnalytics();

  // Be able to handle generic exceptions as well as objects with custom context object
  const handleOnError = (error: Error | { error: Error; context: any }) => {
    let message;
    if ('error' in error && 'context' in error) {
      message = error?.error?.message;
      DataDogLogger.error(error.error, error?.context);
    } else {
      message = error?.message;
      DataDogLogger.error(error);
    }
    trackEvent({
      analyticEvent: ANALYTICS.EVENT.ERROR_MESSAGE_SHOWN,
      details: { error_message: message } as AnalyticErrorShownDetailsType,
    });
  };

  return (
    <ReactErrorBoundary
      {...props}
      fallbackRender={(props) => fallbackRender ?? <DefaultFallback {...props} />}
      onError={handleOnError}
    />
  );
};

export default ErrorBoundary;
